import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SEOLandingTemplate from '../components/SEOLandingTemplate';
import {
  INDUSTRIES,
  PRODUCT_CATEGORIES,
  SERVICES,
  LOCATIONS,
} from '../content/seo';

const REGISTRY = {
  industry: { data: INDUSTRIES, pathPrefix: '/industries', breadcrumb: 'Industries' },
  product: { data: PRODUCT_CATEGORIES, pathPrefix: '/products', breadcrumb: 'Products' },
  service: { data: SERVICES, pathPrefix: '/services', breadcrumb: 'Services' },
  location: { data: LOCATIONS, pathPrefix: '/location', breadcrumb: 'Locations' },
};

export default function SEOEntityPage({ kind }) {
  const { slug } = useParams();
  const reg = REGISTRY[kind];
  if (!reg) return <Navigate to="/" replace />;
  const entity = reg.data.find((e) => e.slug === slug);
  if (!entity) return <Navigate to="/" replace />;
  const siblings = reg.data.filter((e) => e.slug !== slug);
  return (
    <SEOLandingTemplate
      entity={entity}
      kind={kind}
      pathPrefix={reg.pathPrefix}
      breadcrumb={reg.breadcrumb}
      siblings={siblings}
    />
  );
}
